module.exports = __webpack_public_path__ + "static/apply-b94ba072432972c2d953ece5c5de50cb.png";